const routeConfigs = [
  {
    url: '/admin/login',
    component: 'Login'
  }
];

export default routeConfigs;
